var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_386_6573)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.34227 4.05074H6.83594V3.03809H7.34227C8.18118 3.03809 8.86125 3.71816 8.86125 4.55707V8.60771C8.86125 8.88735 9.08794 9.11404 9.36758 9.11404H12.9119V10.1267H10.3802V13.1647C10.3802 14.0036 9.70017 14.6837 8.86125 14.6837H8.35492V13.671H8.86125C9.1409 13.671 9.36758 13.4443 9.36758 13.1647V10.1267C8.52867 10.1267 7.8486 9.44662 7.8486 8.60771V4.55707C7.8486 4.27743 7.62191 4.05074 7.34227 4.05074Z",
    fill: "#0A1E5B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.8211 1.51901H1.77047V5.56964H5.8211V1.51901ZM1.77047 0.506348C1.2112 0.506348 0.757812 0.95974 0.757812 1.51901V5.56964C0.757812 6.1289 1.2112 6.5823 1.77047 6.5823H5.8211C6.38037 6.5823 6.83376 6.1289 6.83376 5.56964V1.51901C6.83376 0.95974 6.38037 0.506348 5.8211 0.506348H1.77047Z",
    fill: "#0A1E5B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9754 7.59493H13.9248V11.6456H17.9754V7.59493ZM13.9248 6.58228C13.3655 6.58228 12.9121 7.03567 12.9121 7.59493V11.6456C12.9121 12.2048 13.3655 12.6582 13.9248 12.6582H17.9754C18.5347 12.6582 18.9881 12.2048 18.9881 11.6456V7.59493C18.9881 7.03567 18.5347 6.58228 17.9754 6.58228H13.9248Z",
    fill: "#0A1E5B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.34259 12.1518H3.29196V16.2025H7.34259V12.1518ZM3.29196 11.1392C2.73269 11.1392 2.2793 11.5926 2.2793 12.1518V16.2025C2.2793 16.7617 2.73269 17.2151 3.29196 17.2151H7.34259C7.90185 17.2151 8.35525 16.7617 8.35525 16.2025V12.1518C8.35525 11.5926 7.90185 11.1392 7.34259 11.1392H3.29196Z",
    fill: "#0A1E5B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_386_6573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 17.7215,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryIcon);
export default __webpack_public_path__ + "static/media/category-icon.f9b5fc17e50886d4a86bae713b3c4d4b.svg";
export { ForwardRef as ReactComponent };